import React, { useEffect } from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import orangeOrb from '../assets/orangeOrb.svg';

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme) => ({
  orangeOrb: {
    position: 'absolute',
    marginTop: '-20rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  container: {
    marginTop: '7.4rem'
  },
  textCont: {
    width: '51%',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  linkText: {
    color: theme.palette.common.blue
  }
}));

const Enough = () => {
  const classes = useStyles();
  const { ref, inView } = useInView({ threshold: 0.5 });
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        transition: {
          type: 'spring',
          duration: 6
        }
      });
    }
    if (!inView) {
      animation.start({ opacity: 0 });
    }
  }, [inView, animation]);

  return (
    <>
      <motion.img
        ref={ref}
        animate={animation}
        src={orangeOrb}
        alt="orange orb graphic"
        className={classes.orangeOrb}
      />
      <Grid container justifyContent="center" alignItems="center" className={classes.container}>
        <Grid container item className={classes.textCont}>
          <Typography variant="h2">Enough is Enough</Typography>
          <Typography varaint="body1" style={{ marginTop: '1.75rem' }}>
            It’s possible to do right by Black and Hispanic women within our existing healthcare
            systems, but creating new solutions starts with understanding the social, cultural and
            economic factors that place Black and Hispanic women of all ages at higher risk. It also
            means listening to women who have firsthand knowledge of these challenges.
          </Typography>
          <Typography varaint="body1" style={{ marginTop: '1.75rem' }}>
            Below, we’ve spoken to some phenomenal women who represent hope, strength, and courage
            in the fight for healthcare equality. Through their stories and the presentation of
            critical facts about breast and cervical cancer, we, along with{' '}
            <a
              href="https://cts.businesswire.com/ct/CT?id=smartlink&url=http%3A%2F%2Fwww.hologic.com%2Fprojecthealthequality&esheet=52426870&newsitemid=20210511005313&lan=en-US&anchor=www.hologic.com%2Fprojecthealthequality&index=1&md5=8c6a3877dbe4300e4a7e26ce797be2d6"
              className={classes.linkText}
              target="_blank"
              rel="sponsored"
            >
              Hologic’s Project Health Equality,{' '}
            </a>
            aim to inform women who may be at risk– as well as the medical professionals who can
            affect change in the communities they serve.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Enough;
